import { useState, useRef, useCallback, useEffect } from 'react';
import ArrowUp from './icons/arrow-up';

export default function P2MobileNavItem({ item, resetParentHeight }) {
  const [isOpened, setIsOpened] = useState(false);
  const bodyDiv = useRef(null);
  const [sectionHeight, setSectionHeight] = useState(0);

  const toggleMenu = useCallback(() => {
    setIsOpened(state => !state);
    resetParentHeight((isOpened ? -1 : 1) * sectionHeight);
  }, [isOpened, sectionHeight]);

  const resetThisHeight = useCallback((diff) => {
    resetParentHeight(diff);
    setSectionHeight(state => state + diff);
  }, []);

  useEffect(() => {
    const callback = () => setSectionHeight(bodyDiv.current.scrollHeight);
    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, []);

  return (
    <div className="polymer-header-mobile-nav-item">
      {item.url 
      ? <a className="polymer-header-mobile-nav-item-name"
        href={item.url}
      >
        <div>{item.name}</div>
      </a>
      : <div 
        className="polymer-header-mobile-nav-item-name"
        onClick={toggleMenu}
      >
        <div>{item.name}</div>
        <ArrowUp isRotated={!isOpened} />
      </div>}
      <div 
        className="polymer-header-mobile-nav-item-sections"
        style={{
          height: isOpened ? sectionHeight : 0,
        }}
        ref={bodyDiv}
      >
        {item.sections && item.sections.map((section, sectionIndex) => (
          <P2MobileNavItemSection 
            section={section} 
            key={sectionIndex} 
            resetParentHeight={resetThisHeight}
          />
        ))}
      </div>
    </div>
  )
}

const P2MobileNavItemSection = ({ section, resetParentHeight }) => {
  const [isOpened, setIsOpened] = useState(false);
  const bodyDiv = useRef(null);

  const toggleMenu = useCallback(() => {
    setIsOpened(state => !state);
    resetParentHeight((isOpened ? -1 : 1) * bodyDiv.current.scrollHeight);
  }, [isOpened]);

  return (
    <div className="polymer-header-mobile-nav-item">
      <div className="polymer-header-mobile-nav-item-name ps-4" onClick={toggleMenu}>
        <div>{section.header}</div>
        <ArrowUp isRotated={!isOpened} />
      </div>
      <div 
        className="polymer-header-mobile-nav-item-sections"
        style={{
          height: isOpened ? bodyDiv.current.scrollHeight : 0
        }}
        ref={bodyDiv}
      >
        {section.links.map((link, linkIndex) => (
          <a key={linkIndex} href={link.url} className="polymer-header-mobile-nav-item-name ps-5">{link.text}</a>
        ))}
      </div>
    </div>
  )
}